import React from 'react';
import Input from '../../ui/inputs/Input';
import DateInput from '../../ui/inputs/DateInput';
import CpfInput from '../../ui/inputs/CpfInput';
import Select from '../../ui/selects/Select';
import DeleteIconButton from '../../ui/buttons/DeleteIconButton';

const KINSHIP_OPTIONS = [
  { label: 'Cônjuge', value: 'Cônjuge' },
  { label: 'Filho (a)', value: 'Filho (a)' },
  { label: 'Pai', value: 'Pai' },
  { label: 'Mãe', value: 'Mãe' },
  { label: 'Companheiro (a)', value: 'Companheiro (a)' },
  { label: 'Irmão (ã)', value: 'Irmão (ã)' },
  { label: 'Sobrinho (a)', value: 'Sobrinho (a)' },
  { label: 'Tio (a)', value: 'Tio (a)' },
  { label: 'Primo (a)', value: 'Primo (a)' },
  { label: 'Avô (ó)', value: 'Avô (ó)' },
  { label: 'Nenhum', value: 'Nenhum' },
  { label: 'Enteado (a)', value: 'Enteado (a)' },
  { label: 'Neto (a)', value: 'Neto (a)' },
  { label: 'Bisneto (a)', value: 'Bisneto (a)' },
  { label: 'Bisavô (ó)', value: 'Bisavô (ó)' },
  { label: 'Menor', value: 'Menor' },
];

const BeneficiaryForm = ({ index, beneficiary, onChange, onRemove, canWrite = true }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(index, { ...beneficiary, [name]: value });
  };

  return (
    <div className="grid grid-cols-12 gap-4 items-end">
      <div className="col-span-12 md:col-span-11 space-y-4">
        <Input
          name="name"
          label="Nome completo"
          value={beneficiary.name || ''}
          onChange={handleChange}
          required
          disabled={!canWrite}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <Select
            required
            name="kinship"
            label="Parentesco"
            value={beneficiary.kinship || ''}
            onChange={handleChange}
            options={KINSHIP_OPTIONS}
            disabled={!canWrite}
          />
          <CpfInput name="cpf" label="CPF" value={beneficiary.cpf || ''} onChange={handleChange} disabled={!canWrite} />
          <DateInput
            required
            name="birthDate"
            label="Data de nascimento"
            value={beneficiary.birthDate || ''}
            onChange={handleChange}
            disabled={!canWrite}
          />
        </div>
      </div>

      {canWrite && (
        <div className="col-span-12 md:col-span-1 flex justify-center items-end h-full">
          <DeleteIconButton onClick={() => onRemove(index)} />
        </div>
      )}
    </div>
  );
};

export default BeneficiaryForm;
